import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=6e1e49d9&scoped=true&"
import script from "./indexs.vue?vue&type=script&lang=js&"
export * from "./indexs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e49d9",
  null
  
)

export default component.exports